// extracted by mini-css-extract-plugin
module.exports = {"circleCard":"circleCard_circleCard__LGwzk","image":"circleCard_image__pxLYk","name":"circleCard_name__bhoB_"};